import { HStack, VStack, type BoxProps } from '../Core';
import { Divider } from '../Divider';
import { Text, type TextProps } from '../Text';

export interface TextDividerProps extends BoxProps {
  text: string;
  dividerProps?: BoxProps;
  textProps?: TextProps;
}

/**
 * @deprecated Use SectionTitle instead.
 * A horizontal divider with a starting Text acting as a title of the divider.
 *
 *
 * Like this:
 * @example
 * Title -------------------------
 */
export function TextDivider({ text, dividerProps, textProps, ...boxProps }: TextDividerProps) {
  return (
    <HStack w="100%" gap="spacing12" alignItems="center" {...boxProps}>
      <Text weight="fontWeightBold" color="colorTextImportant" {...textProps}>
        {text}
      </Text>
      <VStack flex="1">
        <Divider orientation="horizontal" {...dividerProps} />
      </VStack>
    </HStack>
  );
}
